import { VERSION } from './git-version';

export const environment = {
  apiRoot: `api`,
  captchaSiteKey: '6Ler8xQUAAAAACFpSyBQZ85mh501RBaIPFjXuEiK',
  clientIdHeader: 'X-CLIENT-ID',
  intercomId: 'cabzeyor',
  googleTagId: 'GTM-NLJH4LZ',
  segmentKey: '1rJxM5rz5WEhLbhVZa9N1ynkQrbNy3Ll',
  preProduction: false,
  production: true,
  socketUrl: 'ws/ch@userid',
  spriteUrl: `icons/sprite.svg?v=${VERSION.hash}`,
  msTeamsUrl: 'https://teams.microsoft.com/l/app/4ef470d8-e4c6-41fc-a5aa-c532730dd635?source=app-details-dialog',
  type: 'prod',
  googleSSOClientId: '234779255529-mse959b6ehf0vrr2id2o04a8ridirknn.apps.googleusercontent.com',
};
